import { VCS_MODE } from '@journeyapps-platform/types-accounts-hub';

export const getVersionControlMode = (mode: VCS_MODE) => {
  return mode === VCS_MODE.BASIC ? 'Basic (Revisions)' : 'Advanced (Git)';
};
